import { LucideIcon } from 'lucide-react';

interface InfoCardProps {
  icon?: LucideIcon;
  title: string;
  description: string;
  variant?: 'info' | 'success' | 'warning' | 'tip';
}

export default function InfoCard({ icon: Icon, title, description, variant = 'info' }: InfoCardProps) {
  const variants = {
    info: {
      bg: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
      border: '#93c5fd',
      iconColor: '#2563eb',
      titleColor: '#1e40af',
      textColor: '#1e40af'
    },
    success: {
      bg: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
      border: '#86efac',
      iconColor: '#16a34a',
      titleColor: '#166534',
      textColor: '#166534'
    },
    warning: {
      bg: 'linear-gradient(135deg, #fefce8 0%, #fef9c3 100%)',
      border: '#fde047',
      iconColor: '#ca8a04',
      titleColor: '#854d0e',
      textColor: '#854d0e'
    },
    tip: {
      bg: 'linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%)',
      border: '#d8b4fe',
      iconColor: '#9333ea',
      titleColor: '#6b21a8',
      textColor: '#6b21a8'
    }
  };

  const style = variants[variant];

  return (
    <div
      style={{
        padding: '16px 20px',
        background: style.bg,
        borderRadius: '12px',
        border: `1px solid ${style.border}`,
        marginBottom: '16px'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
        {Icon && (
          <Icon
            size={20}
            color={style.iconColor}
            style={{ flexShrink: 0, marginTop: '2px' }}
          />
        )}
        <div style={{ flex: 1 }}>
          <h4
            style={{
              margin: '0 0 6px',
              fontSize: '14px',
              fontWeight: 700,
              color: style.titleColor
            }}
          >
            {title}
          </h4>
          <p
            style={{
              margin: 0,
              fontSize: '13px',
              lineHeight: '1.6',
              color: style.textColor
            }}
          >
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}
